module.exports = __webpack_public_path__ + "static/media/iFood.0c5aba61.webp";